import { loadAllWorkerSessionsForBusiness } from './workerSessionsStorage';
import { readWorkerSessionsSyncForBusiness } from './workerSessionsReadSource';

export function resolveWorkerSessionsForBusiness(businessId, blobFallback = []) {
  if (!businessId) {
    return Array.isArray(blobFallback) ? blobFallback : [];
  }
  try {
    const fromKv = loadAllWorkerSessionsForBusiness(businessId);
    if (Array.isArray(fromKv) && fromKv.length > 0) {
      return fromKv;
    }
  } catch {
    /* ignore */
  }
  if (Array.isArray(blobFallback) && blobFallback.length > 0) {
    return blobFallback;
  }
  try {
    const fromEntity = readWorkerSessionsSyncForBusiness(businessId);
    if (Array.isArray(fromEntity) && fromEntity.length > 0) {
      return fromEntity;
    }
  } catch {
    /* optional entity read */
  }
  return Array.isArray(blobFallback) ? blobFallback : [];
}
